<template>
  <div>
    <template v-if="header">
      <v-toolbar color="transparent" flat height="42">
        <v-toolbar-title class="text--secondary subtitle-2 font-weight-medium">
          <span>Precio por </span>
          <template v-if="tiersMode === 'volume'">volumen</template>
          <template v-if="tiersMode === 'graduated'">volumen gradual</template>
          <template v-else-if="tiersMode === 'package'">paquete</template>
          <template v-else-if="tiersMode === 'package_overage'">paquete con excedente</template>
        </v-toolbar-title>
      </v-toolbar>
      <v-divider />
    </template>
    <v-simple-table dense>
      <template v-slot:default>
        <thead>
          <tr>
            <th style="width: 450px !important;">Unidades</th>
            <th class="text-right">Precio</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="tier in tiers" :key="tier.to">
            <td class="py-2">
              <!-- quantity from -->
              <template v-if="tier.quantity_to">
                <span class="mr-1">
                  <template v-if="['volume', 'graduated'].includes(tiersMode)">de</template>
                  <template v-else-if="['package', 'package_overage'].includes(tiersMode)">entre</template>
                </span>
                <span class="text--secondary font-weight-medium">{{tier.quantity_from}}</span>
              </template>
              <!-- end quantity from -->

              <!-- quantity to -->
              <template v-if="tier.quantity_to">
                <span class="mx-1">
                  <template v-if="['volume', 'graduated'].includes(tiersMode)">hasta</template>
                  <template v-else-if="['package', 'package_overage'].includes(tiersMode)">y</template>
                </span>
                <span class="text--secondary font-weight-medium">{{tier.quantity_to}}</span>
              </template>
              <template v-else>
                <span>más de <span class="text--secondary font-weight-medium">{{(tier.quantity_from - 1)}}</span></span>
              </template>
              <!-- end quantity to -->

              <span class="ml-1 text-secondary">unidades</span>
            </td>
            <td class="text-right">
              <span class="text--secondary font-weight-medium">{{tier.amount | currency(currency)}}</span>
              <span class="mx-1">{{currency}}</span>
            </td>
            <td>
              <span class="text-secondary" v-if="tier.unit_scheme">
                <template v-if="(['all_units', 'overage']).includes(tier.unit_scheme)">cada unidad</template>
                <template v-else-if="tier.unit_scheme === 'tier_units'">cada unidad del tramo</template>
              </span>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>
<script>
import GenericViewMixin from '@/mixins/GenericViewMixin'

export default {
  props: {
    currency: {
      type: String,
      required: true
    },
    header: {
      type: Boolean,
      required: false,
      default: true
    },
    tiers: {
      type: Array,
      required: true
    },
    tiersMode: {
      type: String,
      required: true
    }
  },
  mixins: [
    GenericViewMixin
  ]
}
</script>